import config from "../src/config";
import storage from "../src/storage";

export const airtable = {
  /**
  * Returns common HTTP headers to be used everywhere regardless of the request.
  */
  headers() {
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${config.airtable.token}`,
    }
  },
  /**
  * Get a shop given its name.
  * @param  {string}  name Name of the shop (e.g., homestead-beef-the-beefery).
  */
  async getShopByName(name) {
    const localStorageKey = name;
    var localData = storage.get(localStorageKey);
    if (localData) {
      return JSON.parse(localData);
    }

    let url = new URL(`${config.airtable.baseUrl}`);
    url.searchParams.append("maxRecords", `1`);
    url.searchParams.append("filterByFormula", `SEARCH("${name}",{Name})`);

    let response = await fetch(url.href, {
      method: 'GET',
      headers: this.headers(),
    });
    let data = await response.json();

    if (response.status === 200 && data.records.length > 0) {
      let shop = data.records[0].fields;
      storage.put(localStorageKey, JSON.stringify(shop));

      return shop;
    }

    return null;
  },
  /**
  * Get shops that are either featured of are certified "Pasture for life".
  * Note: used in the home page.
  */
  async getFeaturedAndPastureForLifeCertifiedShopsForHome() {
    const localStorageKey = 'getFeaturedAndPastureForLifeCertifiedShopsForHome';

    var localData = storage.get(localStorageKey);
    if (localData) {
      return JSON.parse(localData);
    }

    let url = new URL(`${config.airtable.baseUrl}`);
    url.searchParams.append("filterByFormula", `AND(TRUE({Published}), OR(FIND("featured",{Flags}) > 0, FIND("pasture_for_life",{Flags}) > 0))`);

    let response = await fetch(url.href, {
      method: 'GET',
      headers: this.headers(),
    });
    let data = await response.json();

    if (response.status === 200 && data.records.length > 0) {
      let shops = data.records.map((item) => item.fields);
      storage.put(localStorageKey, JSON.stringify(shops));

      return shops;
    }

    return null;
  },
  /**
  * Get all shops.
  * Note: used in the results page.
  */
  async getAllShops() {
    const localStorageKey = 'getAllShops';

    var localData = storage.get(localStorageKey);
    if (localData) {
      return JSON.parse(localData);
    }

    let pageSize = 100; // max is 100
    var offset = "";
    var records = Array();

    do {
      let url = new URL(`${config.airtable.baseUrl}`);
      url.searchParams.append("pageSize", `${pageSize}`);
      url.searchParams.append("offset", offset);
      url.searchParams.append("filterByFormula", `TRUE({Published})`);

      let response = await fetch(url.href, {
        method: 'GET',
        headers: this.headers(),
      });
      let data = await response.json();
      console.log(data);

      if (response.status !== 200 || data.records.length < pageSize) {
        offset = "";
      } else {
        records.push(...data.records);
        offset = data.offset;
      }
    } while (offset != "")

    if (records.length > 0) {
      let shops = records.map((item) => item.fields);
      storage.put(localStorageKey, JSON.stringify(shops));

      return shops;
    }

    return null;
  }
};

export default airtable;
